import { DirectSubChannel, SensorPortCommunicationMode } from "../../../portConfigs.js";
import { SensorClusterConfig, SensorElementOutput } from "../types.js";

// ─── McCrometer FC101 (PWM flowmeter) ────────────────────────────────────────
//
// The FC101 uses a pulse-frequency output. Calibration (K-factor) is
// specified per installation from the McCrometer calibration sheet.
//
// The legacy sensor default was kFactor=1 in (L/min)/Hz units. The cluster
// element uses kFactor in L/pulse, so the equivalent default is 1/60.

const sensorElements: SensorElementOutput<"flowmeter">[] = [
    {
        sensorElementConfigKey: "flowmeter",
        parameters: { kFactor: 1 / 60, minimumFrequency: 0, frequencyOffset: 0 },
        legalConvertedRange: [0, null],
        subChannel: DirectSubChannel.PULSE_FREQUENCY,
    },
];

export const mccrometerFlowmeterClusterConfigs: Record<string, SensorClusterConfig<Record<string, never>>> = {
    mccrometerFlowmeterFC101: {
        communicationMode: SensorPortCommunicationMode.DIRECT,
        requiredSubChannels: [DirectSubChannel.PULSE_FREQUENCY],
        optionalSubChannels: [],
        isPermanentlyAttached: false,
        parameterConfigs: {},
        manufacturerName: "McCrometer",
        modelName: "FC101",
        friendlyName: "FC101 Flowmeter",
        friendlyShortName: "FC101 Flow",
        generateSensorElements: () => sensorElements,
        migrationProperties: {
            legacySensorType: "mccrometerFlowmeterFC101",
            legacyParametersToClusterParameters: () => ({}),
            clusterParametersToLegacyParameters: () => ({}),
        },
    },
};
